// extracted by mini-css-extract-plugin
export default {"side":"StickySideNav_side__bzto0","stickable":"StickySideNav_stickable__M2Jss","right":"StickySideNav_right__PRAjt","placeHolderShimmer":"StickySideNav_placeHolderShimmer__7fwyK"};